import React from 'react';

// Standard grey page header (same look as Patients, Communication, etc.)
export default function PageHeader({ section, title, actions }) {
    return (
        <div className="breadcrumb-bar">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-md-4 col-12">
                        <nav aria-label="breadcrumb" className="page-breadcrumb">
                            <ol className="breadcrumb">
                                {section && <li className="breadcrumb-item active" aria-current="page">{section}</li>}
                                <li className="breadcrumb-item active" aria-current="page">{title}</li>
                            </ol>
                        </nav>
                        <h2 className="breadcrumb-title">{title}</h2>
                    </div>
                    {actions && (
                        <div className="col-md-8 col-12">
                            <div className="row breadcrumb-btns">{actions}</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
